import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BillableActivityArrayOrObject: any;
  JSON: any;
  JSONObject: any;
};

export type ActionDefinition = {
  __typename?: 'ActionDefinition';
  actions?: Maybe<Array<Scalars['JSONObject']>>;
  metadata?: Maybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type ActionDefinitionInput = {
  actions?: InputMaybe<Array<Scalars['JSONObject']>>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type ActionDocumentation = {
  __typename?: 'ActionDocumentation';
  relatedActions?: Maybe<Array<Scalars['String']>>;
  requiredServices?: Maybe<Array<Scalars['String']>>;
  usageNotes?: Maybe<Scalars['String']>;
};

export type ActionInfo = {
  __typename?: 'ActionInfo';
  availableScopes?: Maybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  description: Scalars['String'];
  documentation?: Maybe<ActionDocumentation>;
  metadata?: Maybe<ActionMetadata>;
  name: Scalars['String'];
  supportsNesting: Scalars['Boolean'];
  type: Scalars['String'];
};

export type ActionMetadata = {
  __typename?: 'ActionMetadata';
  example?: Maybe<Scalars['JSONObject']>;
  schema?: Maybe<Scalars['JSONObject']>;
};

export type ActionResult = {
  __typename?: 'ActionResult';
  log?: Maybe<Scalars['String']>;
  output?: Maybe<Scalars['JSON']>;
  report?: Maybe<Scalars['JSON']>;
  status: ActionStatus;
  type: Scalars['String'];
};

export enum ActionStatus {
  Complete = 'COMPLETE',
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type AdjustmentUploadDoneInput = {
  fileName: Scalars['String'];
  objectKey: Scalars['String'];
};

export type AdjustmentUploadUrl = {
  __typename?: 'AdjustmentUploadUrl';
  headers: Scalars['JSONObject'];
  objectKey: Scalars['String'];
  url: Scalars['String'];
};

export type AdjustmentUploadUrlInput = {
  fileCategory: Scalars['String'];
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
};

export type Admin = {
  __typename?: 'Admin';
  avatarUrl: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  role: Scalars['String'];
  uuid: Scalars['ID'];
};

export type AggregateHoldsV2ItemType = {
  __typename?: 'AggregateHoldsV2ItemType';
  contractId: Scalars['Int'];
  heldAmount: Scalars['Float'];
  holds: Scalars['String'];
  holdsCount: Scalars['Int'];
  maxFromDate: Scalars['String'];
  maxLastSeenAt: Scalars['String'];
  minFromDate: Scalars['String'];
};

export type AggregateHoldsV2Type = {
  __typename?: 'AggregateHoldsV2Type';
  items: Array<AggregateHoldsV2ItemType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type AssessedRule = {
  __typename?: 'AssessedRule';
  actionLog?: Maybe<Array<ActionResult>>;
  assertionLog?: Maybe<Scalars['JSON']>;
  status: AssessmentStatus;
};

export type AssessmentResult = {
  __typename?: 'AssessmentResult';
  actionsExecuted: Scalars['Float'];
  assertionPassed: Scalars['Float'];
  completed: Scalars['Float'];
  createdAt: Scalars['String'];
  errored: Scalars['Float'];
  id: Scalars['String'];
  ruleAssessmentResultId?: Maybe<Scalars['String']>;
};

export enum AssessmentStatus {
  ActionsExecuted = 'ACTIONS_EXECUTED',
  AssertionPassed = 'ASSERTION_PASSED',
  Completed = 'COMPLETED',
  Errored = 'ERRORED',
  TagCreated = 'TAG_CREATED'
}

export type AssessmentTask = {
  __typename?: 'AssessmentTask';
  actionsExecuted: Scalars['Float'];
  arguments: Scalars['JSON'];
  assertionPassed: Scalars['Float'];
  assessmentResults: Array<AssessmentResult>;
  completed: Scalars['Float'];
  createdAt: Scalars['String'];
  errored: Scalars['Float'];
  id: Scalars['ID'];
  remaining: Scalars['Float'];
  status: Scalars['String'];
  totalAssessments: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type AssessmentTaskList = {
  __typename?: 'AssessmentTaskList';
  assessmentTasks: Array<AssessmentTaskListItem>;
  limit: Scalars['Float'];
  total: Scalars['Float'];
};

export type AssessmentTaskListItem = {
  __typename?: 'AssessmentTaskListItem';
  actionsExecuted: Scalars['Float'];
  arguments: Scalars['JSON'];
  assertionPassed: Scalars['Float'];
  completed: Scalars['Float'];
  createdAt: Scalars['String'];
  errored: Scalars['Float'];
  id: Scalars['ID'];
  remaining: Scalars['Float'];
  status: Scalars['String'];
  totalAssessments: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type Association = {
  __typename?: 'Association';
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
  typeId: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type BaseUser = {
  __typename?: 'BaseUser';
  bio?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pathwayProgramIndications?: Maybe<Array<Scalars['String']>>;
  phoneNumber?: Maybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type BatchClientInsurerType = {
  __typename?: 'BatchClientInsurerType';
  billingType?: Maybe<Scalars['String']>;
  client: ClientType;
  coreContractRule?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insurer: BatchInsurerType;
  isActive: Scalars['Boolean'];
  partnerships: Array<PartnershipType>;
  termDate?: Maybe<Scalars['String']>;
};

export type BatchContractClientInsurerInput = {
  clientId: Scalars['Int'];
  id: Scalars['Int'];
  insurerId: Scalars['Int'];
};

export type BatchContractResponse = {
  __typename?: 'BatchContractResponse';
  clientInsurerId: Scalars['Int'];
  error: Scalars['String'];
  newContract?: Maybe<ContractType>;
  oldContract?: Maybe<ContractType>;
  success: Scalars['Boolean'];
};

export type BatchCreateProgramCapInput = {
  programCaps: Array<BatchProgramCapItemInput>;
};

export type BatchInsurerType = {
  __typename?: 'BatchInsurerType';
  eligibilityRef: Scalars['String'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type BatchProgramCapItemInput = {
  cap: Scalars['Float'];
  clientId: Scalars['Int'];
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type BatchProgramCapResponseItem = {
  __typename?: 'BatchProgramCapResponseItem';
  clientId: Scalars['Int'];
  endDate: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  programCap?: Maybe<BatchProgramCapResult>;
  startDate: Scalars['String'];
  success: Scalars['Boolean'];
};

export type BatchProgramCapResult = {
  __typename?: 'BatchProgramCapResult';
  cap: Scalars['Float'];
  clientId: Scalars['Int'];
  endDate: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  lastModifiedBy: Scalars['String'];
  startDate: Scalars['String'];
};

export enum BillStatusEnum {
  Archived = 'ARCHIVED',
  NonSubmittable = 'NON_SUBMITTABLE',
  Submittable = 'SUBMITTABLE',
  SubmittableWithBypass = 'SUBMITTABLE_WITH_BYPASS'
}

export type BillSubmissionsType = {
  __typename?: 'BillSubmissionsType';
  baseCharge: Scalars['Float'];
  billAmount?: Maybe<Scalars['Float']>;
  claimIdentifier: Scalars['String'];
  contractId?: Maybe<Scalars['Int']>;
  coverageId?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  engagementEvent?: Maybe<EngagementBaseType>;
  eventUuid?: Maybe<Scalars['String']>;
  fromDate: Scalars['String'];
  id: Scalars['Float'];
  internalHolds: Array<InternalHoldBaseType>;
  pathwayId?: Maybe<Scalars['Float']>;
  paymentType: Scalars['String'];
  source: Scalars['String'];
  sourceId: Scalars['Float'];
  status: Scalars['String'];
  submissions: Array<SubmissionRemitsType>;
  subscriptionPackageId?: Maybe<Scalars['Float']>;
  toDate?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type BillableActivityType = {
  __typename?: 'BillableActivityType';
  createdAt: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  engagementTypeId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type BillingModelType = {
  __typename?: 'BillingModelType';
  createdAt: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type BillingType = {
  __typename?: 'BillingType';
  value: Scalars['String'];
};

export type BillsPaginatedType = {
  __typename?: 'BillsPaginatedType';
  items: Array<PaginatedBillType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type BlacklistType = {
  __typename?: 'BlacklistType';
  engagementTypes?: Maybe<Array<Scalars['JSONObject']>>;
  packages?: Maybe<Array<Scalars['String']>>;
};

export type BulkEligibilityCheckInput = {
  billIds: Array<Scalars['Int']>;
  mode: EligibilitySearchDepthEnum;
  note?: InputMaybe<Scalars['String']>;
};

export type BulkUpdateBillingTypeInput = {
  billingType?: InputMaybe<Scalars['String']>;
  contractIds: Array<Scalars['Int']>;
};

export type BulkUpdateBillingTypeResponse = {
  __typename?: 'BulkUpdateBillingTypeResponse';
  contractsUpdated: Scalars['Int'];
};

export type BulkUpdateBillsInput = {
  billIds: Array<Scalars['Int']>;
  clientInsurerId?: InputMaybe<Scalars['Int']>;
  contractId?: InputMaybe<Scalars['Int']>;
  note: Scalars['String'];
  statusChange: BillStatusEnum;
};

export type BulkUpdateBillsResponse = {
  __typename?: 'BulkUpdateBillsResponse';
  details: Scalars['String'];
};

export type BulkUpdateSubmissionsInput = {
  ids: Array<Scalars['Int']>;
  netsuiteId: Scalars['String'];
  note: Scalars['String'];
};

export type BulkUpdateSubmissionsResponse = {
  __typename?: 'BulkUpdateSubmissionsResponse';
  ids: Array<Scalars['Int']>;
};

export type BulkVoidSubmissionsInput = {
  ids: Array<Scalars['Int']>;
  note: Scalars['String'];
  status: Scalars['String'];
};

export type BulkVoidSubscriptionsInput = {
  ids: Array<Scalars['Int']>;
  note: Scalars['String'];
};

export type ClearHoldsInput = {
  billIds: Array<Scalars['Int']>;
  holdTypes?: Array<ClearableHoldTypes>;
};

export type ClearHoldsResponse = {
  __typename?: 'ClearHoldsResponse';
  details: Scalars['String'];
};

export enum ClearableHoldTypes {
  ManualHold = 'MANUAL_HOLD'
}

export type ClientInsurerByClientType = {
  __typename?: 'ClientInsurerByClientType';
  clientsInsurers: Array<ClientInsurerDetailsType>;
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type ClientInsurerDetailsType = {
  __typename?: 'ClientInsurerDetailsType';
  billingType?: Maybe<Scalars['String']>;
  client: ClientType;
  id: Scalars['Int'];
  insurer: InsurerBasicType;
  isActive: Scalars['Boolean'];
  partnerships: Array<PartnershipType>;
  termDate?: Maybe<Scalars['String']>;
};

export type ClientInsurerType = {
  __typename?: 'ClientInsurerType';
  billingType?: Maybe<Scalars['String']>;
  client: ClientType;
  coreContractRule?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insurer: InsurerType;
  isActive: Scalars['Boolean'];
  partnerships: Array<PartnershipType>;
  termDate?: Maybe<Scalars['String']>;
};

export type ClientType = {
  __typename?: 'ClientType';
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type ConsultResultType = {
  __typename?: 'ConsultResultType';
  consultMessage?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  hhUuid: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type ContractPackagesInput = {
  billableActivityTypes?: InputMaybe<Scalars['BillableActivityArrayOrObject']>;
  billingEnabled?: InputMaybe<Scalars['Boolean']>;
  billingModelId?: InputMaybe<Scalars['Int']>;
  billingTypeOverride?: InputMaybe<Scalars['String']>;
  contractId?: InputMaybe<Scalars['Int']>;
  contractTemplateId?: InputMaybe<Scalars['Int']>;
  costShareOptions?: InputMaybe<CostShareOptionInputType>;
  id?: InputMaybe<Scalars['Int']>;
  packageId: Scalars['Int'];
  price?: InputMaybe<Scalars['Float']>;
  rules?: InputMaybe<Scalars['JSON']>;
  startDate?: InputMaybe<Scalars['String']>;
  void?: InputMaybe<Scalars['Boolean']>;
};

export type ContractPackagesType = {
  __typename?: 'ContractPackagesType';
  billableActivityTypes: Array<BillableActivityType>;
  billingEnabled: Scalars['Boolean'];
  billingModel: BillingModelType;
  billingModelId: Scalars['Int'];
  billingTypeOverride?: Maybe<Scalars['String']>;
  contractId: Scalars['Int'];
  contractTemplateId?: Maybe<Scalars['Int']>;
  costShareOptions?: Maybe<CostShareOptionsType>;
  createdAt: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  package: PackageType;
  packageId: Scalars['Int'];
  price: Scalars['Float'];
  rules?: Maybe<Scalars['JSON']>;
  startDate?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  void: Scalars['Boolean'];
};

export type ContractTemplateType = {
  __typename?: 'ContractTemplateType';
  contract: Array<ContractTypeUnion>;
  contractType?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  partnershipId?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['String'];
};

export type ContractTermSummary = {
  __typename?: 'ContractTermSummary';
  numAdminFeeClaims: Scalars['Float'];
  numFeeForServiceEvents: Scalars['Float'];
  numSubmissions: Scalars['Float'];
  numSubscriptions: Scalars['Float'];
  sumSubmissionAmount: Scalars['Float'];
};

export type ContractType = {
  __typename?: 'ContractType';
  acutePrice?: Maybe<Scalars['Float']>;
  billableActivityTypes: Array<BillableActivityType>;
  billingType?: Maybe<Scalars['String']>;
  chronicPrice?: Maybe<Scalars['Float']>;
  clientId: Scalars['Float'];
  clientsInsurerId: Scalars['Float'];
  contract?: Maybe<Array<ContractTypeUnion>>;
  contractPackages: Array<ContractPackagesType>;
  contractTemplateId?: Maybe<Scalars['Float']>;
  contractType?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  globalDailyEngagementCap?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  insurerId: Scalars['Float'];
  lastModifiedBy: Scalars['String'];
  packageEnabled: Scalars['Boolean'];
  partnershipId?: Maybe<Scalars['Float']>;
  startDate: Scalars['String'];
  updatedAt: Scalars['String'];
  userAnnualCap?: Maybe<Scalars['Float']>;
  void: Scalars['Boolean'];
};

export type ContractTypeUnion = EngagementContractType | IndividualMilestonesType | MilestonesType;

export type ContractsPaginatedType = {
  __typename?: 'ContractsPaginatedType';
  items: Array<ContractType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type CorrectionBaseType = {
  __typename?: 'CorrectionBaseType';
  correctionAmount: Scalars['Float'];
  correctionsType: CorrectionTypeEnum;
  createdAt: Scalars['String'];
  lastModifiedBy: Scalars['String'];
  netsuiteId: Scalars['String'];
  submissionId?: Maybe<Scalars['Int']>;
};

export enum CorrectionTypeEnum {
  CreditMemo = 'CREDIT_MEMO',
  InvoiceCorrection = 'INVOICE_CORRECTION'
}

export type CostShareOptionInputType = {
  cadence: Scalars['String'];
  deductionTiming: Scalars['String'];
};

export type CostShareOptionsType = {
  __typename?: 'CostShareOptionsType';
  cadence: Scalars['String'];
  contractPackageId: Scalars['Int'];
  createdAt: Scalars['String'];
  deductionTiming: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type CostShareSetupOptionType = {
  __typename?: 'CostShareSetupOptionType';
  cadence: Array<Scalars['String']>;
  deductionTiming: Array<Scalars['String']>;
};

export type CptCodes = {
  __typename?: 'CptCodes';
  acuteCptCodes?: Maybe<Array<Scalars['String']>>;
};

export type CreateAssessmentTaskInput = {
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  resourceType?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type CreateAssociationInput = {
  type: Scalars['String'];
  typeId: Scalars['String'];
};

export type CreateBatchContractInput = {
  billingType?: InputMaybe<Scalars['String']>;
  clientInsurers: Array<BatchContractClientInsurerInput>;
  contractPackages?: InputMaybe<Array<ContractPackagesInput>>;
  currency?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  globalDailyEngagementCap?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['String'];
  userAnnualCap: Scalars['Float'];
};

export type CreateConfigurationInput = {
  actions: Array<Scalars['JSONObject']>;
  dataProvider: Scalars['String'];
  definition: Scalars['JSONObject'];
  name: Scalars['String'];
};

export type CreateContractInput = {
  acutePrice?: InputMaybe<Scalars['Float']>;
  billableActivityTypes?: InputMaybe<Scalars['BillableActivityArrayOrObject']>;
  billingType?: InputMaybe<Scalars['String']>;
  chronicPrice?: InputMaybe<Scalars['Float']>;
  clientId: Scalars['Float'];
  clientsInsurerId: Scalars['Float'];
  contract?: InputMaybe<Array<Scalars['JSONObject']>>;
  contractPackages?: InputMaybe<Array<ContractPackagesInput>>;
  contractTemplateId?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  globalDailyEngagementCap?: InputMaybe<Scalars['Int']>;
  insurerId: Scalars['Float'];
  packageEnabled?: InputMaybe<Scalars['Boolean']>;
  partnershipId?: InputMaybe<Scalars['Float']>;
  startDate: Scalars['String'];
  userAnnualCap?: InputMaybe<Scalars['Float']>;
};

export type CreateCvsFeeScheduleInput = {
  charge: Scalars['String'];
  daysSupply: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  upc: Scalars['String'];
};

export type CreateDiscountInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<Scalars['Float']>;
  discountType: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<ScopeInput>>;
  startDate: Scalars['String'];
  suppressEmptyCharges: Scalars['Boolean'];
  vbdTiers?: InputMaybe<Array<VbdTierInput>>;
};

export type CreateEsiFeeScheduleInput = {
  description?: InputMaybe<Scalars['String']>;
  paymentType: Scalars['String'];
  price: Scalars['Float'];
  program?: InputMaybe<Scalars['String']>;
  upc: Scalars['String'];
};

export type CreateFacetInput = {
  associations?: InputMaybe<Array<CreateAssociationInput>>;
  description: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CreateFeeScheduleInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityId: Scalars['Int'];
  entityType: FeeScheduleEntityType;
  notes?: InputMaybe<Scalars['String']>;
  paymentSystem: PaymentSystemType;
  paymentType: Scalars['String'];
  price: Scalars['Float'];
};

export type CreateIcdCodeInput = {
  endDate: Scalars['String'];
  indication: Scalars['String'];
  leftCode?: InputMaybe<Scalars['String']>;
  rightCode?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
  universalCode: Scalars['String'];
};

export type CreatePackageInput = {
  name: Scalars['String'];
  packageOffering: PackageOfferingEnum;
  productId?: InputMaybe<Scalars['Int']>;
  programIndications?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateProcedureCodeInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  cptCode: Scalars['String'];
  insurerId?: InputMaybe<Scalars['Int']>;
  modifier1?: InputMaybe<Scalars['String']>;
  modifier2?: InputMaybe<Scalars['String']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  paymentTypeId: Scalars['Int'];
};

export type CreateProgramCapInput = {
  cap: Scalars['Float'];
  clientId: Scalars['Int'];
  endDate: Scalars['String'];
  lockDate?: InputMaybe<Scalars['String']>;
  lockPrice?: InputMaybe<Scalars['Float']>;
  startDate: Scalars['String'];
};

export type CreateRevenueShareInput = {
  applyToPrice: Scalars['Boolean'];
  clientId?: InputMaybe<Scalars['Int']>;
  discount: Scalars['Float'];
  effectiveYear: Scalars['Int'];
  partnershipId?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<ScopeInput>>;
};

export type CreateRuleAssessmentInput = {
  resource: Scalars['String'];
  resourceId: Scalars['String'];
  resourceType?: InputMaybe<Scalars['String']>;
  ruleIds?: InputMaybe<Array<Scalars['String']>>;
  source: Scalars['String'];
  userId: Scalars['String'];
};

export type CreateRuleInput = {
  actions?: InputMaybe<Array<ActionDefinitionInput>>;
  definition: RuleDefinitionInput;
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
  source: Scalars['String'];
};

export type CreateSubscriptionEstimateInput = {
  contractId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['String']>;
  grossAmount: Scalars['Float'];
  reserveAmount: Scalars['Float'];
  startDate: Scalars['String'];
};

export type CreateTagInput = {
  description: Scalars['String'];
  name: Scalars['String'];
};

export type CreateUserTagInput = {
  occurredAt: Scalars['String'];
  resourceId: Scalars['String'];
  source: Scalars['String'];
  tagName: Scalars['String'];
  userId: Scalars['String'];
};

export type CurrencyCodeType = {
  __typename?: 'CurrencyCodeType';
  value: Scalars['String'];
};

export type CvsFeeScheduleType = {
  __typename?: 'CvsFeeScheduleType';
  charge: Scalars['String'];
  createdAt: Scalars['String'];
  daysSupply: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  paymentType?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  upc: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type CvsResponseType = {
  __typename?: 'CvsResponseType';
  errors?: Maybe<Scalars['JSONObject']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  upstreamResponseContent: Scalars['JSONObject'];
};

export type DagRunRequestInput = {
  conf: Scalars['JSONObject'];
  note?: InputMaybe<Scalars['String']>;
};

export type DagRunResponseType = {
  __typename?: 'DagRunResponseType';
  dagId: Scalars['String'];
  dagRunId: Scalars['String'];
  logicalDate: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  state: Scalars['String'];
};

export type DefaultConfigType = {
  __typename?: 'DefaultConfigType';
  engagement: Scalars['String'];
  package: Scalars['String'];
  price: Scalars['Float'];
};

export type DiscountDetail = {
  __typename?: 'DiscountDetail';
  clientId?: Maybe<Scalars['Int']>;
  discount: Scalars['Int'];
  discountDefinitionId: Scalars['Int'];
  discountDetailId: Scalars['Int'];
  discountType: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  insurerId?: Maybe<Scalars['Int']>;
  milestoneDiscount?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  partnershipId?: Maybe<Scalars['Int']>;
  scopes: Array<Scope>;
  startDate: Scalars['String'];
  subscriptionTier: Array<Maybe<Scalars['Int']>>;
  suppressEmptyCharges: Scalars['Boolean'];
  tier: Scalars['Int'];
};

export type DiscountDetailItem = {
  __typename?: 'DiscountDetailItem';
  discount: Scalars['Int'];
  id: Scalars['Int'];
  milestoneDiscount?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  subscriptionTier: Array<Maybe<Scalars['Int']>>;
  tier: Scalars['Int'];
};

export type DiscountUsage = {
  __typename?: 'DiscountUsage';
  discountDetailId?: Maybe<Scalars['Float']>;
  discountPercent?: Maybe<Scalars['Float']>;
  discountSum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Float'];
};

export type DiscountWithDetails = {
  __typename?: 'DiscountWithDetails';
  clientId?: Maybe<Scalars['Int']>;
  discountDetails: Array<DiscountDetailItem>;
  discountType: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insurerId?: Maybe<Scalars['Int']>;
  partnershipId?: Maybe<Scalars['Int']>;
  scopes: Array<Scope>;
  startDate: Scalars['String'];
  suppressEmptyCharges: Scalars['Boolean'];
};

export type DiscountWithDetailsPaginatedType = {
  __typename?: 'DiscountWithDetailsPaginatedType';
  items: Array<DiscountWithDetails>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export enum EligibilitySearchDepthEnum {
  Deep = 'DEEP',
  Standard = 'STANDARD'
}

export type EngagementBaseType = {
  __typename?: 'EngagementBaseType';
  billableCount: Scalars['Int'];
  createdAt: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  eventId?: Maybe<Scalars['Int']>;
  eventType: Scalars['String'];
  eventUuid?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  occurredAt: Scalars['String'];
  pathwayUuid: Scalars['String'];
  programId?: Maybe<Scalars['Int']>;
  programIndication: Scalars['String'];
  queuedAt: Scalars['String'];
  sourceType: Scalars['String'];
  userUuid: Scalars['String'];
};

export type EngagementContractType = {
  __typename?: 'EngagementContractType';
  activityTypes: Array<Scalars['String']>;
  educationalTypes: Array<Scalars['String']>;
  engagementRules: Array<Scalars['JSONObject']>;
  matchType: Scalars['String'];
};

export type EngagementType = {
  __typename?: 'EngagementType';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type EngagementsPaginationType = {
  __typename?: 'EngagementsPaginationType';
  items: Array<EngagementBaseType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type EnrollUsersInput = {
  patientUuids: Array<Scalars['ID']>;
  workflowType: Scalars['String'];
};

export type EnrollUsersModel = {
  __typename?: 'EnrollUsersModel';
  enrolledUuids: Array<Scalars['String']>;
  failedUuids: Array<Scalars['String']>;
};

export type EsiFeeScheduleType = {
  __typename?: 'EsiFeeScheduleType';
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  paymentType: Scalars['String'];
  price: Scalars['Float'];
  program?: Maybe<Scalars['String']>;
  upc: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type Facet = {
  __typename?: 'Facet';
  associations?: Maybe<Array<Association>>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
  value: Scalars['String'];
};

export type FacetsList = {
  __typename?: 'FacetsList';
  count: Scalars['Float'];
  facets: Array<Facet>;
};

export type FeeForServiceEvent = {
  __typename?: 'FeeForServiceEvent';
  adminUuid?: Maybe<Scalars['String']>;
  contractId: Scalars['Int'];
  contractPackageId: Scalars['Int'];
  createdAt: Scalars['String'];
  engagementEventId: Scalars['Int'];
  id: Scalars['Float'];
  lastModifiedBy: Scalars['String'];
  occurredAt: Scalars['String'];
  pathwayUuid: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['Int'];
  userUuid: Scalars['String'];
  void: Scalars['Boolean'];
};

export type FeeForServiceEventPaginated = {
  __typename?: 'FeeForServiceEventPaginated';
  items: Array<FeeForServiceEvent>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export enum FeeScheduleEntityType {
  Client = 'CLIENT',
  Partnership = 'PARTNERSHIP'
}

export type FeeScheduleType = {
  __typename?: 'FeeScheduleType';
  createdAt: Scalars['String'];
  enabled: Scalars['Boolean'];
  entityId: Scalars['Int'];
  entityType: FeeScheduleEntityType;
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  paymentSystem: PaymentSystemType;
  paymentType: Scalars['String'];
  price: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type FeeSchedulesPaginatedType = {
  __typename?: 'FeeSchedulesPaginatedType';
  items: Array<FeeScheduleType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type FileConfigurationInput = {
  bucket: Scalars['String'];
  columnMappings: Scalars['JSONObject'];
  description: Scalars['String'];
  encodingDetection: Scalars['Boolean'];
  entityTags: Scalars['JSONObject'];
  fileOperations?: InputMaybe<Array<Scalars['JSONObject']>>;
  groupOperations?: InputMaybe<Array<Scalars['JSONObject']>>;
  individualOperations: Array<Scalars['JSONObject']>;
  name: Scalars['String'];
  parser: Scalars['JSONObject'];
  pgpEncrypted?: InputMaybe<Scalars['Boolean']>;
  provider: Scalars['String'];
  regex: Scalars['String'];
};

export type FileDetails = {
  __typename?: 'FileDetails';
  schemas: Scalars['JSONObject'];
};

export type FileUploadStatus = {
  __typename?: 'FileUploadStatus';
  status: Scalars['String'];
};

export type GenerateProgramCapReportInput = {
  programCapId: Scalars['Int'];
};

export type GetCvsEligibilityInput = {
  clientCode: Scalars['String'];
  dateOfBirth: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender: Scalars['String'];
  inquiryDate?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Float']>;
};

export type GetFileConfigurationFrontendResponse = {
  __typename?: 'GetFileConfigurationFrontendResponse';
  bucket: Scalars['String'];
  columnMappings: Scalars['JSONObject'];
  description: Scalars['String'];
  encodingDetection: Scalars['Boolean'];
  entityTags: Scalars['JSONObject'];
  fileOperations: Array<Scalars['JSONObject']>;
  groupOperations: Array<Scalars['JSONObject']>;
  individualOperations: Array<Scalars['JSONObject']>;
  name: Scalars['String'];
  parser: Scalars['JSONObject'];
  provider: Scalars['String'];
  regex: Scalars['String'];
};

export type GetFileConfigurationsResponseType = {
  __typename?: 'GetFileConfigurationsResponseType';
  items: Array<Scalars['JSONObject']>;
  page: Scalars['Float'];
  pages: Scalars['Float'];
  size: Scalars['Float'];
  total: Scalars['Float'];
};

export type GetIndividualOperationsInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type GoogleFileInputType = {
  fileCategory: Scalars['String'];
  fileLink: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type HealthRecord = {
  __typename?: 'HealthRecord';
  createdAt: Scalars['String'];
  data: Scalars['JSONObject'];
  id: Scalars['ID'];
  origin?: Maybe<Scalars['String']>;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  source: Scalars['String'];
  userId: Scalars['String'];
};

export type HealthRecordLinks = {
  __typename?: 'HealthRecordLinks';
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
};

export type HealthRecordMetadata = {
  __typename?: 'HealthRecordMetadata';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  origin?: Maybe<Scalars['String']>;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  source: Scalars['String'];
  userId: Scalars['String'];
};

export type HealthRecordSources = {
  __typename?: 'HealthRecordSources';
  count: Scalars['Float'];
  sources: Array<Scalars['String']>;
};

export type HealthRecordsList = {
  __typename?: 'HealthRecordsList';
  count: Scalars['Float'];
  healthRecords: Array<HealthRecordMetadata>;
  links: HealthRecordLinks;
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
};

export type HoldDetailsType = {
  __typename?: 'HoldDetailsType';
  clearedAt?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['JSON']>;
  holdType: Scalars['String'];
  insurerId?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
};

export type IcdCode = {
  __typename?: 'IcdCode';
  createdAt: Scalars['String'];
  endDate: Scalars['String'];
  id: Scalars['Int'];
  indication: Scalars['String'];
  lastModifiedBy: Scalars['String'];
  leftCode?: Maybe<Scalars['String']>;
  rightCode?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  universalCode: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type IcdCodesPaginated = {
  __typename?: 'IcdCodesPaginated';
  items: Array<IcdCode>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type IndividualMilestonesType = {
  __typename?: 'IndividualMilestonesType';
  billableActivityTypes: Array<Scalars['String']>;
  conditions: Array<MilestoneConditionType>;
  name: Scalars['String'];
  payment: Scalars['Float'];
};

export type InsurerBasicType = {
  __typename?: 'InsurerBasicType';
  eligibilityRef: Scalars['String'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type InsurerType = {
  __typename?: 'InsurerType';
  eligibilityRef: Scalars['String'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type InternalHoldBaseType = {
  __typename?: 'InternalHoldBaseType';
  billId: Scalars['Float'];
  clearedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  details?: Maybe<Scalars['JSON']>;
  holdType: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type InternalHoldType = {
  __typename?: 'InternalHoldType';
  value: Scalars['String'];
};

export type ListAssessmentTasksInput = {
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type ListBatchesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<PdgFileParsingBatchStatus>;
};

export type ListConfigurationsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  dataProvider?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PdgConfigurationStatus>;
};

export type ListFacetsInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
};

export type ListHealthRecordsInput = {
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  next?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type ListIngestionsInput = {
  createdAfter?: InputMaybe<Scalars['String']>;
  createdBefore?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  dataProvider?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<PdgFileProcessingStatus>;
};

export type ListRecordsInput = {
  batchId: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ListRuleAssessmentsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  resourceId?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type ListRulesInput = {
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RuleStatus>;
};

export type ListTagsInput = {
  deleted?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ListUserTagsInput = {
  facetName?: InputMaybe<Scalars['String']>;
  occurredFrom?: InputMaybe<Scalars['String']>;
  occurredTo?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['String']>;
};

export type ManualHoldInput = {
  billIds: Array<Scalars['Int']>;
  note: Scalars['String'];
};

export type ManualHoldResponse = {
  __typename?: 'ManualHoldResponse';
  details: Scalars['String'];
};

export type MappingType = {
  __typename?: 'MappingType';
  options: Array<Scalars['JSONObject']>;
  values: Scalars['JSONObject'];
};

export type MilestoneConditionType = {
  __typename?: 'MilestoneConditionType';
  function: Scalars['String'];
  threshold?: Maybe<Scalars['Float']>;
};

export type MilestoneDiscountInput = {
  c1: Scalars['Float'];
  c2: Scalars['Float'];
  c3: Scalars['Float'];
};

export type MilestonesType = {
  __typename?: 'MilestonesType';
  billableActivityTypes: Array<Scalars['String']>;
  conditions: Array<MilestoneConditionType>;
  dateOfServiceOffset: Scalars['Float'];
  dayRange: Array<Scalars['Int']>;
  name: Scalars['String'];
  payment: Scalars['Float'];
};

export type ModuleType = {
  __typename?: 'ModuleType';
  description: Scalars['String'];
  id: Scalars['Float'];
  identifier: Scalars['String'];
  name: Scalars['String'];
  schema: Scalars['JSONObject'];
  version: Scalars['Float'];
};

export type ModulesResponse = {
  __typename?: 'ModulesResponse';
  items: Array<ModuleType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adjustmentUploadDone: TaskBase;
  batchCreateProgramCap: Array<BatchProgramCapResponseItem>;
  bulkEligibilityCheck: WorkflowBase;
  bulkUpdateBillingType: BulkUpdateBillingTypeResponse;
  bulkUpdateBills: BulkUpdateBillsResponse;
  bulkUpdateSubmissions: BulkUpdateSubmissionsResponse;
  bulkVoidSubmissions: Array<Scalars['Int']>;
  bulkVoidSubscriptions: Array<Scalars['Int']>;
  clearHolds: ClearHoldsResponse;
  createAssessmentTask: AssessmentTask;
  createBatchContract: Array<BatchContractResponse>;
  createContract: ContractType;
  createContractPackage: ContractPackagesType;
  createCvsFeeSchedule: CvsFeeScheduleType;
  createDiscount: Array<DiscountDetail>;
  createEsiFeeSchedule: EsiFeeScheduleType;
  createFacet: Facet;
  createFeeSchedule: FeeScheduleType;
  createFileConfiguration: UpsertFileConfigurationResponseType;
  createIcdCode: IcdCode;
  createManualHold: ManualHoldResponse;
  createPackage: PackageType;
  createPackageContract: ContractType;
  createProcedureCode: ProcedureCode;
  createProgramCap: ProgramCap;
  createRevenueShare: Array<RevenueShareDetail>;
  createRule: Rule;
  createRuleAssessment: RuleAssessment;
  createSubscriptionEstimate: SubscriptionEstimateType;
  createTag: Tag;
  createUserTag: UserTag;
  deleteCvsFeeSchedule: Scalars['Boolean'];
  deleteEsiFeeSchedule: Scalars['Boolean'];
  deleteFeeSchedule: Scalars['Boolean'];
  deleteIcdCode: Scalars['Boolean'];
  deletePackage: Scalars['Boolean'];
  deleteProcedureCode: Scalars['Boolean'];
  deleteRule: Rule;
  deleteTag: Tag;
  deleteUserTag: UserTag;
  enrollUsers: EnrollUsersModel;
  generateProgramCapReport: Scalars['Boolean'];
  getAdjustmentUploadUrl: AdjustmentUploadUrl;
  googleFileUpload: TaskBase;
  pdgControlIngestion: PdgControlResult;
  pdgCreateConfiguration: PdgConfiguration;
  pdgUpdateConfiguration: PdgConfiguration;
  pdgUpdateConfigurationStatus: PdgConfiguration;
  processCopayment: ProcessCopaymentResponse;
  runClaimsManualWebDag: DagRunResponseType;
  setPhoneForUser: Scalars['Boolean'];
  updateAssessmentTask: AssessmentTask;
  updateContract: ContractType;
  updateContractPackage: ContractPackagesType;
  updateCvsFeeSchedule: CvsFeeScheduleType;
  updateDiscount: Array<DiscountDetail>;
  updateEsiFeeSchedule: EsiFeeScheduleType;
  updateFeeSchedule: FeeScheduleType;
  updateFileConfiguration: UpsertFileConfigurationResponseType;
  updateIcdCode: IcdCode;
  updatePackage: PackageType;
  updateProcedureCode: ProcedureCode;
  updateProgramCap: ProgramCap;
  updateRevenueShare: Array<RevenueShareDetail>;
  updateRule: Rule;
  updateSubscriptionEstimate: SubscriptionEstimateType;
};


export type MutationAdjustmentUploadDoneArgs = {
  input: AdjustmentUploadDoneInput;
};


export type MutationBatchCreateProgramCapArgs = {
  batchCreateProgramCapInput: BatchCreateProgramCapInput;
  dryRun?: Scalars['Boolean'];
};


export type MutationBulkEligibilityCheckArgs = {
  bulkEligibilityCheckInput: BulkEligibilityCheckInput;
};


export type MutationBulkUpdateBillingTypeArgs = {
  input: BulkUpdateBillingTypeInput;
};


export type MutationBulkUpdateBillsArgs = {
  bulkUpdateBillsInput: BulkUpdateBillsInput;
};


export type MutationBulkUpdateSubmissionsArgs = {
  bulkUpdateSubmissionsInput: BulkUpdateSubmissionsInput;
};


export type MutationBulkVoidSubmissionsArgs = {
  bulkVoidSubmissionsInput: BulkVoidSubmissionsInput;
};


export type MutationBulkVoidSubscriptionsArgs = {
  bulkVoidSubscriptionsInput: BulkVoidSubscriptionsInput;
};


export type MutationClearHoldsArgs = {
  clearHoldsInput: ClearHoldsInput;
};


export type MutationCreateAssessmentTaskArgs = {
  createAssessmentTaskInput: CreateAssessmentTaskInput;
};


export type MutationCreateBatchContractArgs = {
  batchContractInput: CreateBatchContractInput;
};


export type MutationCreateContractArgs = {
  contractInput: CreateContractInput;
};


export type MutationCreateContractPackageArgs = {
  contractPackageInput: ContractPackagesInput;
};


export type MutationCreateCvsFeeScheduleArgs = {
  cvsFeeScheduleInput: CreateCvsFeeScheduleInput;
};


export type MutationCreateDiscountArgs = {
  discountInput: CreateDiscountInput;
};


export type MutationCreateEsiFeeScheduleArgs = {
  esiFeeScheduleInput: CreateEsiFeeScheduleInput;
};


export type MutationCreateFacetArgs = {
  createFacetInput: CreateFacetInput;
};


export type MutationCreateFeeScheduleArgs = {
  feeScheduleInput: CreateFeeScheduleInput;
};


export type MutationCreateFileConfigurationArgs = {
  createFileConfigurationInput: FileConfigurationInput;
};


export type MutationCreateIcdCodeArgs = {
  icdCodeInput: CreateIcdCodeInput;
};


export type MutationCreateManualHoldArgs = {
  manualHoldInput: ManualHoldInput;
};


export type MutationCreatePackageArgs = {
  packageInput: CreatePackageInput;
};


export type MutationCreatePackageContractArgs = {
  contractInput: CreateContractInput;
};


export type MutationCreateProcedureCodeArgs = {
  procedureCodeInput: CreateProcedureCodeInput;
};


export type MutationCreateProgramCapArgs = {
  createProgramCapInput: CreateProgramCapInput;
};


export type MutationCreateRevenueShareArgs = {
  revenueShareInput: CreateRevenueShareInput;
};


export type MutationCreateRuleArgs = {
  createRuleInput: CreateRuleInput;
};


export type MutationCreateRuleAssessmentArgs = {
  createRuleAssessmentInput: CreateRuleAssessmentInput;
};


export type MutationCreateSubscriptionEstimateArgs = {
  input: CreateSubscriptionEstimateInput;
};


export type MutationCreateTagArgs = {
  createTagInput: CreateTagInput;
};


export type MutationCreateUserTagArgs = {
  createUserTagInput: CreateUserTagInput;
};


export type MutationDeleteCvsFeeScheduleArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteEsiFeeScheduleArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteFeeScheduleArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteIcdCodeArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePackageArgs = {
  packageId: Scalars['Int'];
};


export type MutationDeleteProcedureCodeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRuleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserTagArgs = {
  id: Scalars['String'];
};


export type MutationEnrollUsersArgs = {
  input: EnrollUsersInput;
};


export type MutationGenerateProgramCapReportArgs = {
  generateProgramCapReportInput: GenerateProgramCapReportInput;
};


export type MutationGetAdjustmentUploadUrlArgs = {
  input: AdjustmentUploadUrlInput;
};


export type MutationGoogleFileUploadArgs = {
  fileInput: GoogleFileInputType;
};


export type MutationPdgControlIngestionArgs = {
  action: PdgControlAction;
  eventId: Scalars['String'];
};


export type MutationPdgCreateConfigurationArgs = {
  input: CreateConfigurationInput;
};


export type MutationPdgUpdateConfigurationArgs = {
  id: Scalars['String'];
  input: UpdateConfigurationInput;
};


export type MutationPdgUpdateConfigurationStatusArgs = {
  id: Scalars['String'];
  status: PdgConfigurationStatus;
};


export type MutationProcessCopaymentArgs = {
  processCopaymentInput: ProcessCopaymentInput;
};


export type MutationRunClaimsManualWebDagArgs = {
  dagRunRequestInput: DagRunRequestInput;
};


export type MutationSetPhoneForUserArgs = {
  hhUuid: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationUpdateAssessmentTaskArgs = {
  id: Scalars['String'];
  updateAssessmentTaskInput: UpdateAssessmentTaskInput;
};


export type MutationUpdateContractArgs = {
  contractId: Scalars['Int'];
  contractInput: UpdateContractInput;
};


export type MutationUpdateContractPackageArgs = {
  contractPackageId: Scalars['Int'];
  contractPackageInput: ContractPackagesInput;
};


export type MutationUpdateCvsFeeScheduleArgs = {
  cvsFeeScheduleInput: UpdateCvsFeeScheduleInput;
  id: Scalars['Int'];
};


export type MutationUpdateDiscountArgs = {
  discountInput: UpdateDiscountInput;
};


export type MutationUpdateEsiFeeScheduleArgs = {
  esiFeeScheduleInput: UpdateEsiFeeScheduleInput;
  id: Scalars['Int'];
};


export type MutationUpdateFeeScheduleArgs = {
  feeScheduleInput: UpdateFeeScheduleInput;
  id: Scalars['Int'];
};


export type MutationUpdateFileConfigurationArgs = {
  id: Scalars['Float'];
  updateFileConfigurationInput: FileConfigurationInput;
};


export type MutationUpdateIcdCodeArgs = {
  icdCodeInput: UpdateIcdCodeInput;
  id: Scalars['Int'];
};


export type MutationUpdatePackageArgs = {
  packageId: Scalars['Int'];
  packageInput: UpdatePackageInput;
};


export type MutationUpdateProcedureCodeArgs = {
  id: Scalars['Int'];
  procedureCodeInput: UpdateProcedureCodeInput;
};


export type MutationUpdateProgramCapArgs = {
  updateProgramCapInput: UpdateProgramCapInput;
};


export type MutationUpdateRevenueShareArgs = {
  revenueShareInput: UpdateRevenueShareInput;
};


export type MutationUpdateRuleArgs = {
  id: Scalars['String'];
  updateRuleInput: UpdateRuleInput;
};


export type MutationUpdateSubscriptionEstimateArgs = {
  id: Scalars['Int'];
  input: UpdateSubscriptionEstimateInput;
};

export enum PackageOfferingEnum {
  Product = 'PRODUCT',
  ProgramIndication = 'PROGRAM_INDICATION'
}

export type PackageOfferingsType = {
  __typename?: 'PackageOfferingsType';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  packageId: Scalars['Int'];
  packageOffering: Scalars['String'];
  productId?: Maybe<Scalars['Int']>;
  programIndication?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type PackageRulesType = {
  __typename?: 'PackageRulesType';
  billingModels: Scalars['JSONObject'];
};

export type PackageType = {
  __typename?: 'PackageType';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  isEditable?: Maybe<Scalars['Boolean']>;
  lastModifiedBy: Scalars['String'];
  name: Scalars['String'];
  packageOfferings: Array<PackageOfferingsType>;
  updatedAt: Scalars['String'];
};

export type PaginatedBillType = {
  __typename?: 'PaginatedBillType';
  baseCharge: Scalars['Float'];
  billAmount?: Maybe<Scalars['Float']>;
  billId: Scalars['Float'];
  claimId: Scalars['String'];
  contractId?: Maybe<Scalars['Float']>;
  dateOfService: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  holdDetails?: Maybe<HoldDetailsType>;
  netsuiteId?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  sourceId: Scalars['Float'];
  status: Scalars['String'];
  submissionAmount?: Maybe<Scalars['Float']>;
  submissionDate?: Maybe<Scalars['String']>;
  submissionId?: Maybe<Scalars['Float']>;
  submissionStatus?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
  userUuid: Scalars['String'];
};

export type PaginatedSubmissionType = {
  __typename?: 'PaginatedSubmissionType';
  baseCharge: Scalars['Float'];
  billAmount?: Maybe<Scalars['Float']>;
  billId: Scalars['Float'];
  clientPrice?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  coverageId?: Maybe<Scalars['Float']>;
  dateOfService: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  netsuiteId?: Maybe<Scalars['String']>;
  paymentType: Scalars['String'];
  source: Scalars['String'];
  sourceId: Scalars['Float'];
  submissionAmount?: Maybe<Scalars['Float']>;
  submissionDate?: Maybe<Scalars['String']>;
  submissionId: Scalars['Float'];
  submissionStatus?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
  userUuid?: Maybe<Scalars['String']>;
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Float']>;
};

export type PartnershipType = {
  __typename?: 'PartnershipType';
  allowCohortExpansion: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  partnershipType: Scalars['String'];
  requiresStateCredentials: Scalars['Boolean'];
};

export type Pathway = {
  __typename?: 'Pathway';
  indication: Scalars['String'];
  program: Scalars['String'];
  screening: Screening;
  totalPoints: Scalars['Float'];
};

export enum PaymentSystemType {
  Alight = 'ALIGHT',
  Bcbsal = 'BCBSAL',
  Bcbsma = 'BCBSMA',
  Cvs = 'CVS',
  Esi = 'ESI',
  Netsuite = 'NETSUITE',
  Stonebrook = 'STONEBROOK',
  Waystar = 'WAYSTAR'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  code: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PdgActionTypeDefinition = {
  __typename?: 'PdgActionTypeDefinition';
  description: Scalars['String'];
  fields: Array<Scalars['JSONObject']>;
  label: Scalars['String'];
  scopes: Array<Scalars['String']>;
  type: Scalars['String'];
};

export type PdgActionsCatalog = {
  __typename?: 'PdgActionsCatalog';
  actionTypes: Array<PdgActionTypeDefinition>;
};

export type PdgAssessmentMatch = {
  __typename?: 'PdgAssessmentMatch';
  configurationId: Scalars['String'];
  configurationName: Scalars['String'];
  configurationStatus: Scalars['String'];
  createdAt: Scalars['String'];
  eventId: Scalars['String'];
  id: Scalars['String'];
  matched: Scalars['Boolean'];
  report?: Maybe<Scalars['JSONObject']>;
};

export type PdgAssessmentsList = {
  __typename?: 'PdgAssessmentsList';
  items: Array<PdgAssessmentMatch>;
};

export type PdgBatchHeatmapCell = {
  __typename?: 'PdgBatchHeatmapCell';
  batchId: Scalars['String'];
  byteOffsetEnd: Scalars['String'];
  byteOffsetStart: Scalars['String'];
  createdAt: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  rowCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['String']>;
  status: PdgFileParsingBatchStatus;
  updatedAt: Scalars['String'];
};

export type PdgBatchTotals = {
  __typename?: 'PdgBatchTotals';
  completed: Scalars['Int'];
  failed: Scalars['Int'];
  inProgress: Scalars['Int'];
  pending: Scalars['Int'];
  skipped: Scalars['Int'];
  total: Scalars['Int'];
};

export type PdgBatchesList = {
  __typename?: 'PdgBatchesList';
  items: Array<PdgBatchHeatmapCell>;
  pageInfo: PdgPageInfo;
  totals: PdgBatchTotals;
};

export type PdgChildWorkflowProgress = {
  __typename?: 'PdgChildWorkflowProgress';
  cachedCount?: Maybe<Scalars['Int']>;
  outboxEventsEmitted?: Maybe<Scalars['Int']>;
  pendingCount: Scalars['Int'];
  resolvedCount: Scalars['Int'];
};

export type PdgChildWorkflowSummary = {
  __typename?: 'PdgChildWorkflowSummary';
  endedAt?: Maybe<Scalars['String']>;
  progress?: Maybe<PdgChildWorkflowProgress>;
  startedAt: Scalars['String'];
  status: Scalars['String'];
  workflowId: Scalars['String'];
  workflowType: Scalars['String'];
};

export type PdgConfiguration = {
  __typename?: 'PdgConfiguration';
  actions: Array<Scalars['JSONObject']>;
  createdAt: Scalars['String'];
  dataProvider: Scalars['String'];
  definition: Scalars['JSONObject'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: PdgConfigurationStatus;
  updatedAt: Scalars['String'];
};

export enum PdgConfigurationStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type PdgConfigurationsList = {
  __typename?: 'PdgConfigurationsList';
  items: Array<PdgConfiguration>;
  pageInfo: PdgPageInfo;
};

export enum PdgControlAction {
  Cancel = 'CANCEL',
  Pause = 'PAUSE',
  Resume = 'RESUME'
}

export type PdgControlResult = {
  __typename?: 'PdgControlResult';
  action: PdgControlAction;
  eventId: Scalars['String'];
  status: PdgFileProcessingStatus;
};

export type PdgDataProvidersList = {
  __typename?: 'PdgDataProvidersList';
  items: Array<Scalars['String']>;
};

export enum PdgFileParsingBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Skipped = 'SKIPPED'
}

export enum PdgFileProcessingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Finalizing = 'FINALIZING',
  Parsing = 'PARSING',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Resolving = 'RESOLVING',
  Validating = 'VALIDATING'
}

export type PdgFileRecordPreview = {
  __typename?: 'PdgFileRecordPreview';
  batchId: Scalars['String'];
  createdAt: Scalars['String'];
  eventId: Scalars['String'];
  id: Scalars['String'];
  originalRowIndex: Scalars['Int'];
  rawData: Scalars['JSONObject'];
};

export type PdgIngestionDetail = {
  __typename?: 'PdgIngestionDetail';
  bucket?: Maybe<Scalars['String']>;
  childWorkflow?: Maybe<PdgChildWorkflowSummary>;
  completedAt?: Maybe<Scalars['String']>;
  completedBatches: Scalars['Int'];
  createdAt: Scalars['String'];
  dataProvider?: Maybe<Scalars['String']>;
  eTag?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  eventTime?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  liveProgress?: Maybe<PdgWorkflowProgress>;
  liveProgressSource: Scalars['String'];
  recordMapping: PdgRecordMappingCounts;
  s3Key: Scalars['String'];
  sourceResolution: PdgSourceResolutionCounts;
  stageHistory: Array<PdgStageHistoryEntry>;
  status: PdgFileProcessingStatus;
  temporalWorkflowId: Scalars['String'];
  totalBatches: Scalars['Int'];
  totalRowsParsed: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PdgIngestionSummary = {
  __typename?: 'PdgIngestionSummary';
  bucket?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  completedBatches: Scalars['Int'];
  createdAt: Scalars['String'];
  dataProvider?: Maybe<Scalars['String']>;
  eventId: Scalars['String'];
  fileExtension?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  s3Key: Scalars['String'];
  status: PdgFileProcessingStatus;
  totalBatches: Scalars['Int'];
  totalRowsParsed: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PdgIngestionSummaryStats = {
  __typename?: 'PdgIngestionSummaryStats';
  byStatus: Scalars['JSONObject'];
  totalRowsParsed: Scalars['String'];
  window: PdgSummaryWindow;
};

export type PdgIngestionsList = {
  __typename?: 'PdgIngestionsList';
  items: Array<PdgIngestionSummary>;
  pageInfo: PdgPageInfo;
};

export type PdgPageInfo = {
  __typename?: 'PdgPageInfo';
  hasNextPage: Scalars['Boolean'];
  nextCursor?: Maybe<Scalars['String']>;
};

export type PdgQuarantinedCounts = {
  __typename?: 'PdgQuarantinedCounts';
  ambiguous: Scalars['String'];
  noMatch: Scalars['String'];
  total: Scalars['String'];
};

export type PdgRecordMappingCounts = {
  __typename?: 'PdgRecordMappingCounts';
  finalized: PdgRecordMappingFinalized;
  live: PdgRecordMappingLive;
};

export type PdgRecordMappingFinalized = {
  __typename?: 'PdgRecordMappingFinalized';
  dropped: Scalars['String'];
  failed: Scalars['String'];
  mapped: Scalars['String'];
};

export type PdgRecordMappingLive = {
  __typename?: 'PdgRecordMappingLive';
  byFailureReason: Scalars['JSONObject'];
  dropped: Scalars['String'];
  failed: Scalars['String'];
  mapped: Scalars['String'];
  pending: Scalars['String'];
  source: Scalars['String'];
};

export type PdgRecordsList = {
  __typename?: 'PdgRecordsList';
  items: Array<PdgFileRecordPreview>;
  pageInfo: PdgPageInfo;
};

export type PdgSourceResolutionCounts = {
  __typename?: 'PdgSourceResolutionCounts';
  failed: Scalars['String'];
  quarantined: PdgQuarantinedCounts;
  resolved: Scalars['String'];
};

export type PdgStageHistoryEntry = {
  __typename?: 'PdgStageHistoryEntry';
  durationMs?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['String']>;
  stage: Scalars['String'];
  startedAt: Scalars['String'];
  status: Scalars['String'];
};

export type PdgSummaryWindow = {
  __typename?: 'PdgSummaryWindow';
  hours: Scalars['Int'];
  since: Scalars['String'];
};

export type PdgValidationReport = {
  __typename?: 'PdgValidationReport';
  createdAt: Scalars['String'];
  eventId: Scalars['String'];
  id: Scalars['String'];
  report: Scalars['JSONObject'];
  status: Scalars['String'];
};

export type PdgWorkflowProgress = {
  __typename?: 'PdgWorkflowProgress';
  completedBatches: Scalars['Int'];
  currentBatchIndex: Scalars['Int'];
  eventId: Scalars['String'];
  failedBatches: Scalars['Int'];
  isCancelled: Scalars['Boolean'];
  isPaused: Scalars['Boolean'];
  percentComplete: Scalars['Float'];
  status: Scalars['String'];
  totalBatches: Scalars['Int'];
  totalRowsFailed: Scalars['Int'];
  totalRowsParsed: Scalars['Int'];
  validationStatus?: Maybe<Scalars['String']>;
};

export type ProcedureCode = {
  __typename?: 'ProcedureCode';
  clientId?: Maybe<Scalars['Int']>;
  cptCode: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  insurerId?: Maybe<Scalars['Int']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  modifier1?: Maybe<Scalars['String']>;
  modifier2?: Maybe<Scalars['String']>;
  partnershipId?: Maybe<Scalars['Int']>;
  paymentType?: Maybe<PaymentType>;
  paymentTypeId: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type ProcedureCodesPaginated = {
  __typename?: 'ProcedureCodesPaginated';
  items: Array<ProcedureCode>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type ProcessCopaymentInput = {
  billIds: Array<Scalars['Int']>;
  copayAmount: Scalars['Float'];
};

export type ProcessCopaymentResponse = {
  __typename?: 'ProcessCopaymentResponse';
  workflowIds: Array<Scalars['String']>;
};

export type ProductOffering = {
  __typename?: 'ProductOffering';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  name: Scalars['String'];
  productId: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type ProductType = {
  __typename?: 'ProductType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ProgramCap = {
  __typename?: 'ProgramCap';
  cap: Scalars['Float'];
  clientId: Scalars['Int'];
  correctedUserBasedLockPrice?: Maybe<Scalars['Float']>;
  correctedUserBasedLockPriceCalculatedAt?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  lockDate?: Maybe<Scalars['String']>;
  lockPrice?: Maybe<Scalars['Float']>;
  startDate: Scalars['String'];
};

export type ProgramCapPaginated = {
  __typename?: 'ProgramCapPaginated';
  items: Array<ProgramCap>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type ProgramCapRefund = {
  __typename?: 'ProgramCapRefund';
  averageStickerPrice: Scalars['Float'];
  cap: Scalars['Float'];
  clientId: Scalars['Float'];
  endDate: Scalars['String'];
  lockDate?: Maybe<Scalars['String']>;
  lockPrice?: Maybe<Scalars['Float']>;
  numMembers: Scalars['Float'];
  programCapId: Scalars['Float'];
  refundPerMember: Scalars['Float'];
  reportLink?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  sumAmount: Scalars['Float'];
  totalRefundAmount: Scalars['Float'];
};

export type ProgramIndicationType = {
  __typename?: 'ProgramIndicationType';
  id: Scalars['Int'];
  identifier: Scalars['String'];
  indicationName: Scalars['String'];
  programId: Scalars['Int'];
  programName: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  aggregateHoldsV2: AggregateHoldsV2Type;
  getAllClients: Array<ClientType>;
  getAllEngagementTypes: Array<EngagementType>;
  getAllInsurers: Array<InsurerType>;
  getAllInternalHoldTypes: Array<InternalHoldType>;
  getAllPackages: Array<PackageType>;
  getAllProducts: Array<ProductType>;
  getAssessmentTask: AssessmentTask;
  getBillById: BillSubmissionsType;
  getBillingModels: Array<BillingModelType>;
  getBillingTypes: Array<BillingType>;
  getBills: BillsPaginatedType;
  getBillsByFeeForServiceEventId: Array<BillSubmissionsType>;
  getBillsBySubscriptionId: Array<BillSubmissionsType>;
  getClaimsManualWebDagRunStatus: DagRunResponseType;
  getClientInsurerById: ClientInsurerType;
  getClientInsurersByClient: ClientInsurerByClientType;
  getClientInsurersByIds: Array<BatchClientInsurerType>;
  getColumnMappings: MappingType;
  getConsultResultById: ConsultResultType;
  getContractIds: Array<Scalars['Int']>;
  getContractTemplates: Array<ContractTemplateType>;
  getContractTermSummary: ContractTermSummary;
  getContractsV2: ContractsPaginatedType;
  getCostShareSetupOptions: CostShareSetupOptionType;
  getCurrencyCodes: Array<CurrencyCodeType>;
  getCvsEligibility: CvsResponseType;
  getCvsFeeSchedules: Array<CvsFeeScheduleType>;
  getDiscountUsage: Array<DiscountUsage>;
  getDiscounts: Array<DiscountDetail>;
  getDiscountsPaginated: DiscountWithDetailsPaginatedType;
  getEngagementsByUserUuid: EngagementsPaginationType;
  getEsiFeeSchedules: Array<EsiFeeScheduleType>;
  getFacet: Facet;
  getFeeForServiceEngagements: EngagementsPaginationType;
  getFeeForServiceEvents: FeeForServiceEventPaginated;
  getFeeScheduleById: FeeScheduleType;
  getFeeSchedules: FeeSchedulesPaginatedType;
  getFileConfiguration: GetFileConfigurationFrontendResponse;
  getFileConfigurations: GetFileConfigurationsResponseType;
  getFileDetails: FileDetails;
  getFileUploadStatus: FileUploadStatus;
  getHealthRecord: HealthRecord;
  getIcdCodes: IcdCodesPaginated;
  getIndividualOperations: Array<ModuleType>;
  getPackageRules: PackageRulesType;
  getParserModules: ModulesResponse;
  getPartnerships: Array<PartnershipType>;
  getPaymentTypes: Array<PaymentType>;
  getPhoneStatusForUser: UserPhoneStatus;
  getProcedureCodes: ProcedureCodesPaginated;
  getProgramCapRefundById: ProgramCapRefund;
  getProgramCaps: ProgramCapPaginated;
  getProgramIndicationsById: Array<ProgramIndicationType>;
  getResolvedProcedureCodes: Array<ProcedureCode>;
  getRevenueShares: Array<RevenueShareDetail>;
  getRule: Rule;
  getRuleAssessment: RuleAssessment;
  getSubmissions: SubmissionsPaginatedType;
  getSubscriptionEngagements: EngagementsPaginationType;
  getSubscriptionHoldsByUser: Array<SubscriptionHoldType>;
  getSubscriptions: SubscriptionsPaginationType;
  getSupportedActions: SupportedActionsResult;
  getTask: TaskInformation;
  getTemporalWorkflow: TemporalWorkflowInformation;
  getUnbilledBills: UnbilledBillsPaginatedType;
  getUserTag: UserTag;
  getUserUuidById: UserLimitedType;
  getValidContractsForHoldRelease: Array<ContractType>;
  getWorkflowsByFilter: WorkflowListPayload;
  listAssessmentTasks: AssessmentTaskList;
  listFacets: FacetsList;
  listHealthRecordSources: HealthRecordSources;
  listHealthRecords: HealthRecordsList;
  listHealthRecordsAtCursor: HealthRecordsList;
  listRuleAssessments: RuleAssessmentsList;
  listRules: RulesList;
  listTags: TagsList;
  listUserTags: UserTagsList;
  pdgActionsCatalog: PdgActionsCatalog;
  pdgConfiguration: PdgConfiguration;
  pdgConfigurations: PdgConfigurationsList;
  pdgDataProviders: PdgDataProvidersList;
  pdgIngestion: PdgIngestionDetail;
  pdgIngestionAssessments: PdgAssessmentsList;
  pdgIngestionBatches: PdgBatchesList;
  pdgIngestionRecords: PdgRecordsList;
  pdgIngestionSummary: PdgIngestionSummaryStats;
  pdgIngestionValidation: PdgValidationReport;
  pdgIngestions: PdgIngestionsList;
  productOfferings: Array<ProductOffering>;
  subscriptionEstimates: Array<SubscriptionEstimateType>;
};


export type QueryAggregateHoldsV2Args = {
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  fromDate?: InputMaybe<Scalars['String']>;
  holdTypes?: InputMaybe<Array<Scalars['String']>>;
  minHeldAmount?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetAssessmentTaskArgs = {
  id: Scalars['String'];
};


export type QueryGetBillByIdArgs = {
  billId: Scalars['Int'];
};


export type QueryGetBillsArgs = {
  billAmount?: InputMaybe<Scalars['Float']>;
  billIds?: InputMaybe<Array<Scalars['Int']>>;
  billStatuses?: InputMaybe<Array<BillStatusEnum>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['String']>;
  held?: InputMaybe<Scalars['Boolean']>;
  internalHoldTypes?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  paymentTypes?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Array<Array<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  sourceEndDate?: InputMaybe<Scalars['String']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceStartDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  submissionStatuses?: InputMaybe<Array<SubmissionStatusEnum>>;
  submitted?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  userUuids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetBillsByFeeForServiceEventIdArgs = {
  feeForServiceEventId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetBillsBySubscriptionIdArgs = {
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetClaimsManualWebDagRunStatusArgs = {
  dagRunId: Scalars['String'];
};


export type QueryGetClientInsurerByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetClientInsurersByClientArgs = {
  id: Scalars['String'];
};


export type QueryGetClientInsurersByIdsArgs = {
  billingType?: InputMaybe<Scalars['String']>;
  billingTypes?: InputMaybe<Array<Scalars['String']>>;
  clientIdentifier?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  insurerIds?: InputMaybe<Array<Scalars['Int']>>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  scope?: InputMaybe<ScopeType>;
};


export type QueryGetConsultResultByIdArgs = {
  consultId: Scalars['String'];
};


export type QueryGetContractIdsArgs = {
  billingTypes?: InputMaybe<Array<Scalars['String']>>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  clientsInsurerIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['String']>;
  includeVoided?: InputMaybe<Scalars['Boolean']>;
  insurerIds?: InputMaybe<Array<Scalars['Int']>>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetContractTemplatesArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetContractTermSummaryArgs = {
  contractId: Scalars['Int'];
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type QueryGetContractsV2Args = {
  billingTypes?: InputMaybe<Array<Scalars['String']>>;
  clientIds?: InputMaybe<Array<Scalars['Int']>>;
  clientsInsurerIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  contractType?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  includeVoided?: InputMaybe<Scalars['Boolean']>;
  insurerIds?: InputMaybe<Array<Scalars['Int']>>;
  packageEnabled?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  requireBillingTypeOverrideMatch?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetCvsEligibilityArgs = {
  getCvsEligibilityInput: GetCvsEligibilityInput;
};


export type QueryGetDiscountUsageArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  discountDetailIds?: InputMaybe<Array<Scalars['Int']>>;
  partnershipId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDiscountsArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  discountDefinitionId?: InputMaybe<Scalars['Int']>;
  discountDetailId?: InputMaybe<Scalars['Int']>;
  discountType?: InputMaybe<Scalars['String']>;
  inquiryDate?: InputMaybe<Scalars['String']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  scopeType?: InputMaybe<ScopeType>;
};


export type QueryGetDiscountsPaginatedArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  discountDefinitionId?: InputMaybe<Scalars['Int']>;
  discountDetailId?: InputMaybe<Scalars['Int']>;
  discountType?: InputMaybe<Scalars['String']>;
  filterPackages?: InputMaybe<Scalars['Boolean']>;
  inquiryDate?: InputMaybe<Scalars['String']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  scopeType?: InputMaybe<ScopeType>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetEngagementsByUserUuidArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['String'];
  uuid: Scalars['String'];
};


export type QueryGetFacetArgs = {
  id: Scalars['String'];
};


export type QueryGetFeeForServiceEngagementsArgs = {
  feeForServiceEventId: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFeeForServiceEventsArgs = {
  contractId?: InputMaybe<Scalars['Int']>;
  includeVoid?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  userUuids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetFeeScheduleByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetFeeSchedulesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityIds?: InputMaybe<Array<Scalars['Int']>>;
  entityType: FeeScheduleEntityType;
  page?: InputMaybe<Scalars['Int']>;
  paymentSystems?: InputMaybe<Array<PaymentSystemType>>;
  paymentTypes?: InputMaybe<Array<Scalars['String']>>;
  priceMax?: InputMaybe<Scalars['Float']>;
  priceMin?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFileConfigurationArgs = {
  id: Scalars['Float'];
};


export type QueryGetFileConfigurationsArgs = {
  paginationInput: PaginationInput;
};


export type QueryGetFileUploadStatusArgs = {
  taskId: Scalars['String'];
};


export type QueryGetHealthRecordArgs = {
  id: Scalars['String'];
};


export type QueryGetIcdCodesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetIndividualOperationsArgs = {
  getIndividualOperationsInput: GetIndividualOperationsInput;
};


export type QueryGetPartnershipsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGetPhoneStatusForUserArgs = {
  hhUuid: Scalars['String'];
};


export type QueryGetProcedureCodesArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  paymentType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProgramCapRefundByIdArgs = {
  programCapId: Scalars['Int'];
};


export type QueryGetProgramCapsArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  programCapIds?: InputMaybe<Array<Scalars['Int']>>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProgramIndicationsByIdArgs = {
  programIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetResolvedProcedureCodesArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetRevenueSharesArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  effectiveYear?: InputMaybe<Scalars['Int']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  revenueShareDefinitionId?: InputMaybe<Scalars['Int']>;
  scopeType?: InputMaybe<ScopeType>;
};


export type QueryGetRuleArgs = {
  id: Scalars['String'];
};


export type QueryGetRuleAssessmentArgs = {
  id: Scalars['String'];
};


export type QueryGetSubmissionsArgs = {
  billIds?: InputMaybe<Array<Scalars['Int']>>;
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  creditMemoIds?: InputMaybe<Array<Scalars['String']>>;
  netsuiteIds?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sourceEndDate?: InputMaybe<Scalars['String']>;
  sourceIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceStartDate?: InputMaybe<Scalars['String']>;
  submissionEndDate?: InputMaybe<Scalars['String']>;
  submissionIds?: InputMaybe<Array<Scalars['Int']>>;
  submissionStartDate?: InputMaybe<Scalars['String']>;
  submissionStatuses?: InputMaybe<Array<SubmissionStatusEnum>>;
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetSubscriptionEngagementsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  subscriptionId: Scalars['Int'];
};


export type QueryGetSubscriptionHoldsByUserArgs = {
  userId?: InputMaybe<Scalars['Int']>;
  userUuid?: InputMaybe<Scalars['String']>;
};


export type QueryGetSubscriptionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeVoid?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
  userUuid?: InputMaybe<Scalars['String']>;
};


export type QueryGetTaskArgs = {
  taskId: Scalars['String'];
};


export type QueryGetTemporalWorkflowArgs = {
  workflowId: Scalars['String'];
};


export type QueryGetUnbilledBillsArgs = {
  contractIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  paymentTypes?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserTagArgs = {
  id: Scalars['String'];
};


export type QueryGetUserUuidByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetValidContractsForHoldReleaseArgs = {
  clientsInsurerId: Scalars['Int'];
  maxDateOfService: Scalars['String'];
  minDateOfService: Scalars['String'];
};


export type QueryGetWorkflowsByFilterArgs = {
  workflowFiltersInputDto: WorkflowListFiltersInputDto;
  workflowType?: InputMaybe<Scalars['String']>;
};


export type QueryListAssessmentTasksArgs = {
  listAssessmentTasksInput?: InputMaybe<ListAssessmentTasksInput>;
};


export type QueryListFacetsArgs = {
  listFacetsInput?: InputMaybe<ListFacetsInput>;
};


export type QueryListHealthRecordsArgs = {
  listHealthRecordsInput: ListHealthRecordsInput;
};


export type QueryListHealthRecordsAtCursorArgs = {
  cursorPath: Scalars['String'];
};


export type QueryListRuleAssessmentsArgs = {
  listRuleAssessmentsInput?: InputMaybe<ListRuleAssessmentsInput>;
};


export type QueryListRulesArgs = {
  listRulesInput?: InputMaybe<ListRulesInput>;
};


export type QueryListTagsArgs = {
  listTagsInput?: InputMaybe<ListTagsInput>;
};


export type QueryListUserTagsArgs = {
  listUserTagsInput: ListUserTagsInput;
};


export type QueryPdgConfigurationArgs = {
  id: Scalars['String'];
};


export type QueryPdgConfigurationsArgs = {
  input?: InputMaybe<ListConfigurationsInput>;
};


export type QueryPdgIngestionArgs = {
  eventId: Scalars['String'];
};


export type QueryPdgIngestionAssessmentsArgs = {
  eventId: Scalars['String'];
};


export type QueryPdgIngestionBatchesArgs = {
  eventId: Scalars['String'];
  input?: InputMaybe<ListBatchesInput>;
};


export type QueryPdgIngestionRecordsArgs = {
  eventId: Scalars['String'];
  input: ListRecordsInput;
};


export type QueryPdgIngestionSummaryArgs = {
  windowHours?: InputMaybe<Scalars['Int']>;
};


export type QueryPdgIngestionValidationArgs = {
  eventId: Scalars['String'];
};


export type QueryPdgIngestionsArgs = {
  input?: InputMaybe<ListIngestionsInput>;
};


export type QuerySubscriptionEstimatesArgs = {
  contractId?: InputMaybe<Scalars['Int']>;
};

export type RemitBaseType = {
  __typename?: 'RemitBaseType';
  createdAt: Scalars['String'];
  icn?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  patientPaymentAmount: Scalars['Float'];
  payer: Scalars['String'];
  paymentAmount: Scalars['Float'];
  paymentDate?: Maybe<Scalars['String']>;
  paymentNumber?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  responseDate: Scalars['String'];
  sourceOfRecord: Scalars['String'];
};

export type RevenueShareDetail = {
  __typename?: 'RevenueShareDetail';
  applyToPrice: Scalars['Boolean'];
  clientId?: Maybe<Scalars['Int']>;
  discount: Scalars['Float'];
  effectiveYear: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  partnershipId?: Maybe<Scalars['Int']>;
  revenueShareDefinitionId: Scalars['Int'];
  revenueShareDetailId: Scalars['Int'];
  scopes: Array<Scope>;
  subscriptionTier: Array<Maybe<Scalars['Int']>>;
  tier: Scalars['Int'];
};

export type Rule = {
  __typename?: 'Rule';
  actions?: Maybe<Array<ActionDefinition>>;
  createdAt: Scalars['String'];
  definition: RuleDefinition;
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  resourceTypes?: Maybe<Array<Scalars['String']>>;
  source: Scalars['String'];
  status: RuleStatus;
  updatedAt: Scalars['String'];
  version: Scalars['Float'];
};

export type RuleAssessment = {
  __typename?: 'RuleAssessment';
  assessedRules: Array<AssessedRule>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  resourceId: Scalars['String'];
  resourceType?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['String'];
};

export type RuleAssessmentsList = {
  __typename?: 'RuleAssessmentsList';
  ruleAssessments: Array<RuleAssessment>;
  total: Scalars['Float'];
};

export type RuleDefinition = {
  __typename?: 'RuleDefinition';
  criteria: Array<Scalars['JSONObject']>;
  name: Scalars['String'];
  operator: Scalars['String'];
};

export type RuleDefinitionInput = {
  criteria: Array<Scalars['JSONObject']>;
  name: Scalars['String'];
  operator: Scalars['String'];
};

export enum RuleStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type RulesList = {
  __typename?: 'RulesList';
  rules: Array<Rule>;
  total: Scalars['Float'];
};

export type RulesType = {
  __typename?: 'RulesType';
  countPerContract?: Maybe<Scalars['Float']>;
  disabledBefore?: Maybe<Scalars['String']>;
  offeringsType: Scalars['String'];
  schema?: Maybe<Scalars['String']>;
};

export type Scope = {
  __typename?: 'Scope';
  scopeableId?: Maybe<Scalars['Int']>;
  scopeableType: ScopeableType;
};

export type ScopeInput = {
  scopeableId?: InputMaybe<Scalars['Int']>;
  scopeableType: ScopeableType;
};

export enum ScopeType {
  Exclusive = 'EXCLUSIVE',
  Inclusive = 'INCLUSIVE'
}

export enum ScopeableType {
  Global = 'GLOBAL',
  Package = 'PACKAGE',
  ProductOffering = 'PRODUCT_OFFERING',
  Program = 'PROGRAM'
}

export type Screening = {
  __typename?: 'Screening';
  id: Scalars['String'];
};

export type SubmissionRemitsType = {
  __typename?: 'SubmissionRemitsType';
  billId: Scalars['Float'];
  corrections: Array<CorrectionBaseType>;
  coverageId?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  id: Scalars['Float'];
  netsuiteId?: Maybe<Scalars['String']>;
  remits: Array<RemitBaseType>;
  status: Scalars['String'];
  submissionAmount: Scalars['Float'];
  submissionDate: Scalars['String'];
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum SubmissionStatusEnum {
  Accepted = 'ACCEPTED',
  Denied = 'DENIED',
  Duplicate = 'DUPLICATE',
  Reversal = 'REVERSAL',
  Submitted = 'SUBMITTED',
  Unknown = 'UNKNOWN',
  Void = 'VOID'
}

export type SubmissionsPaginatedType = {
  __typename?: 'SubmissionsPaginatedType';
  items: Array<PaginatedSubmissionType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type SubscriptionEstimateType = {
  __typename?: 'SubscriptionEstimateType';
  contractId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  grossAmount: Scalars['Float'];
  id: Scalars['Int'];
  lastModifiedBy: Scalars['String'];
  reserveAmount: Scalars['Float'];
  startDate: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type SubscriptionHoldType = {
  __typename?: 'SubscriptionHoldType';
  clearedAt?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['JSONObject']>;
  firstSeenAt: Scalars['String'];
  hitCount: Scalars['Float'];
  id: Scalars['Float'];
  lastSeenAt: Scalars['String'];
  programId?: Maybe<Scalars['Float']>;
  reason: Scalars['String'];
  userId: Scalars['Float'];
  userUuid: Scalars['String'];
};

export type SubscriptionPackageType = {
  __typename?: 'SubscriptionPackageType';
  contractPackageId: Scalars['Float'];
  createdAt: Scalars['String'];
  eventUuid: Scalars['String'];
  id: Scalars['Float'];
  packageCap: Scalars['Float'];
  startsAt: Scalars['String'];
  subscriptionId: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type SubscriptionTierInput = {
  lower?: InputMaybe<Scalars['Int']>;
  upper?: InputMaybe<Scalars['Int']>;
};

export type SubscriptionType = {
  __typename?: 'SubscriptionType';
  contractId: Scalars['Float'];
  createdAt: Scalars['String'];
  endsAt: Scalars['String'];
  id: Scalars['Float'];
  pathwayId: Scalars['Float'];
  pathwayUuid: Scalars['String'];
  programId?: Maybe<Scalars['Float']>;
  startsAt: Scalars['String'];
  subscriptionPackages?: Maybe<Array<SubscriptionPackageType>>;
  termDate?: Maybe<Scalars['String']>;
  userId: Scalars['Float'];
  userUuid: Scalars['String'];
  void: Scalars['Boolean'];
  yearCount: Scalars['Float'];
};

export type SubscriptionsPaginationType = {
  __typename?: 'SubscriptionsPaginationType';
  items: Array<SubscriptionType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type SupportedActionsResult = {
  __typename?: 'SupportedActionsResult';
  actions: Array<ActionInfo>;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type TagsList = {
  __typename?: 'TagsList';
  count: Scalars['Float'];
  tags: Array<Tag>;
};

export type Task = {
  __typename?: 'Task';
  adminUuid?: Maybe<Scalars['ID']>;
  completedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  dueDate?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  selection?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type TaskBase = {
  __typename?: 'TaskBase';
  taskId: Scalars['String'];
};

export type TaskInformation = {
  __typename?: 'TaskInformation';
  name?: Maybe<TaskName>;
  result?: Maybe<Scalars['JSON']>;
  status: Scalars['String'];
};

export enum TaskName {
  EligibilityRecheckTask = 'ELIGIBILITY_RECHECK_TASK',
  MonitorTask = 'MONITOR_TASK',
  RegenerateBillTask = 'REGENERATE_BILL_TASK',
  UploadFileTask = 'UPLOAD_FILE_TASK',
  UploadFromGsheetsTask = 'UPLOAD_FROM_GSHEETS_TASK'
}

export type TemporalWorkflowInformation = {
  __typename?: 'TemporalWorkflowInformation';
  failureMessage?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSON']>;
  status: Scalars['String'];
  workflowId: Scalars['String'];
  workflowType: Scalars['String'];
};

export type UnbilledBillType = {
  __typename?: 'UnbilledBillType';
  billsCount: Scalars['Float'];
  contractId: Scalars['Float'];
  unbilled?: Maybe<Scalars['Float']>;
};

export type UnbilledBillsPaginatedType = {
  __typename?: 'UnbilledBillsPaginatedType';
  items: Array<UnbilledBillType>;
  page: Scalars['Float'];
  pages?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

export type UpdateAssessmentTaskInput = {
  status: Scalars['String'];
};

export type UpdateConfigurationInput = {
  actions?: InputMaybe<Array<Scalars['JSONObject']>>;
  dataProvider?: InputMaybe<Scalars['String']>;
  definition?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateContractInput = {
  acutePrice?: InputMaybe<Scalars['Float']>;
  billableActivityTypes?: InputMaybe<Scalars['BillableActivityArrayOrObject']>;
  billingType?: InputMaybe<Scalars['String']>;
  chronicPrice?: InputMaybe<Scalars['Float']>;
  clientId?: InputMaybe<Scalars['Float']>;
  clientsInsurerId?: InputMaybe<Scalars['Float']>;
  contract?: InputMaybe<Array<Scalars['JSONObject']>>;
  contractPackages?: InputMaybe<Array<ContractPackagesInput>>;
  contractTemplateId?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  globalDailyEngagementCap?: InputMaybe<Scalars['Int']>;
  insurerId?: InputMaybe<Scalars['Float']>;
  packageEnabled?: InputMaybe<Scalars['Boolean']>;
  partnershipId?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['String']>;
  userAnnualCap?: InputMaybe<Scalars['Float']>;
  void?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCvsFeeScheduleInput = {
  charge?: InputMaybe<Scalars['String']>;
  daysSupply?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  upc?: InputMaybe<Scalars['String']>;
};

export type UpdateDiscountInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<Scalars['Float']>;
  discountDefinitionId: Scalars['Int'];
  discountType?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<ScopeInput>>;
  startDate?: InputMaybe<Scalars['String']>;
  suppressEmptyCharges?: InputMaybe<Scalars['Boolean']>;
  vbdTiers?: InputMaybe<Array<VbdTierInput>>;
};

export type UpdateEsiFeeScheduleInput = {
  description?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  program?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<Scalars['String']>;
};

export type UpdateFeeScheduleInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<FeeScheduleEntityType>;
  notes?: InputMaybe<Scalars['String']>;
  paymentSystem?: InputMaybe<PaymentSystemType>;
  paymentType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
};

export type UpdateIcdCodeInput = {
  endDate?: InputMaybe<Scalars['String']>;
  indication?: InputMaybe<Scalars['String']>;
  leftCode?: InputMaybe<Scalars['String']>;
  rightCode?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  universalCode?: InputMaybe<Scalars['String']>;
};

export type UpdatePackageInput = {
  name?: InputMaybe<Scalars['String']>;
  packageOffering?: InputMaybe<PackageOfferingEnum>;
  productId?: InputMaybe<Scalars['Int']>;
  programIndications?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateProcedureCodeInput = {
  clientId?: InputMaybe<Scalars['Int']>;
  cptCode?: InputMaybe<Scalars['String']>;
  insurerId?: InputMaybe<Scalars['Int']>;
  modifier1?: InputMaybe<Scalars['String']>;
  modifier2?: InputMaybe<Scalars['String']>;
  partnershipId?: InputMaybe<Scalars['Int']>;
  paymentTypeId?: InputMaybe<Scalars['Int']>;
};

export type UpdateProgramCapInput = {
  cap?: InputMaybe<Scalars['Float']>;
  clientId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lockDate?: InputMaybe<Scalars['String']>;
  lockPrice?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type UpdateRevenueShareInput = {
  applyToPrice?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Float']>;
  effectiveYear?: InputMaybe<Scalars['Int']>;
  revenueShareDefinitionId: Scalars['Int'];
  scopes?: InputMaybe<Array<ScopeInput>>;
};

export type UpdateRuleInput = {
  actions?: InputMaybe<Array<ActionDefinitionInput>>;
  definition?: InputMaybe<RuleDefinitionInput>;
  resourceTypes?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RuleStatus>;
};

export type UpdateSubscriptionEstimateInput = {
  endDate?: InputMaybe<Scalars['String']>;
  grossAmount?: InputMaybe<Scalars['Float']>;
  reserveAmount?: InputMaybe<Scalars['Float']>;
};

export type UpsertFileConfigurationResponseType = {
  __typename?: 'UpsertFileConfigurationResponseType';
  created_at: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
  updated_at: Scalars['String'];
};

export type UserLimitedType = {
  __typename?: 'UserLimitedType';
  uuid?: Maybe<Scalars['ID']>;
};

export type UserPhoneStatus = {
  __typename?: 'UserPhoneStatus';
  auth0: Array<Scalars['String']>;
  hhUuid: Scalars['String'];
  userService: Array<Scalars['String']>;
};

export type UserTag = {
  __typename?: 'UserTag';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  resourceId: Scalars['String'];
  source: Scalars['String'];
  tagId: Scalars['Float'];
  tagName: Scalars['String'];
  userId: Scalars['String'];
};

export type UserTagsList = {
  __typename?: 'UserTagsList';
  count: Scalars['Float'];
  userTags: Array<UserTag>;
};

export type VbdTierInput = {
  discount: Scalars['Float'];
  milestoneDiscount: MilestoneDiscountInput;
  subscriptionTier: SubscriptionTierInput;
  tier: Scalars['Int'];
};

export type WorkflowBase = {
  __typename?: 'WorkflowBase';
  workflowId: Scalars['String'];
};

export type WorkflowError = {
  __typename?: 'WorkflowError';
  error: Scalars['String'];
  fieldName: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type WorkflowListFiltersInputDto = {
  adminUuids?: InputMaybe<Array<Scalars['ID']>>;
  excludeStates?: InputMaybe<Array<Scalars['String']>>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
  patientUuids?: InputMaybe<Array<Scalars['ID']>>;
  useCoverage?: InputMaybe<Scalars['Boolean']>;
};

export type WorkflowListPayload = {
  __typename?: 'WorkflowListPayload';
  errors: Array<WorkflowError>;
  id: Scalars['String'];
  pageNumber: Scalars['Float'];
  pageSize: Scalars['Float'];
  workflows: Array<WorkflowPayload>;
};

export type WorkflowPayload = {
  __typename?: 'WorkflowPayload';
  adminUuids?: Maybe<Array<Scalars['ID']>>;
  coveringAdmins?: Maybe<Array<Admin>>;
  cptCodes?: Maybe<CptCodes>;
  createdAt: Scalars['String'];
  customFields?: Maybe<Scalars['JSONObject']>;
  id: Scalars['Float'];
  isPastDue?: Maybe<Scalars['Boolean']>;
  lastCompletedAt?: Maybe<Scalars['String']>;
  latestTaskDate?: Maybe<Scalars['String']>;
  latestTaskId?: Maybe<Scalars['Float']>;
  pathway?: Maybe<Pathway>;
  patient?: Maybe<BaseUser>;
  patientUuid: Scalars['String'];
  priority?: Maybe<Scalars['Int']>;
  progress?: Maybe<Array<Scalars['Float']>>;
  referenceEventId?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  tasks?: Maybe<Array<Task>>;
  type: Scalars['String'];
  updatedAt: Scalars['String'];
  viewed: Scalars['Boolean'];
};

export type CreateTagMutationVariables = Exact<{
  createTagInput: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', id: string } };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'Tag', id: string } };

export type ListTagsQueryVariables = Exact<{
  listTagsInput?: InputMaybe<ListTagsInput>;
}>;


export type ListTagsQuery = { __typename?: 'Query', listTags: { __typename?: 'TagsList', count: number, tags: Array<{ __typename?: 'Tag', id: string, name: string, description: string, createdAt: string, updatedAt: string, deletedAt?: string | null }> } };


export const CreateTagDocument = gql`
    mutation CreateTag($createTagInput: CreateTagInput!) {
  createTag(createTagInput: $createTagInput) {
    id
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      createTagInput: // value for 'createTagInput'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: String!) {
  deleteTag(id: $id) {
    id
  }
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const ListTagsDocument = gql`
    query listTags($listTagsInput: ListTagsInput) {
  listTags(listTagsInput: $listTagsInput) {
    tags {
      id
      name
      description
      createdAt
      updatedAt
      deletedAt
    }
    count
  }
}
    `;

/**
 * __useListTagsQuery__
 *
 * To run a query within a React component, call `useListTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTagsQuery({
 *   variables: {
 *      listTagsInput: // value for 'listTagsInput'
 *   },
 * });
 */
export function useListTagsQuery(baseOptions?: Apollo.QueryHookOptions<ListTagsQuery, ListTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTagsQuery, ListTagsQueryVariables>(ListTagsDocument, options);
      }
export function useListTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTagsQuery, ListTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTagsQuery, ListTagsQueryVariables>(ListTagsDocument, options);
        }
export type ListTagsQueryHookResult = ReturnType<typeof useListTagsQuery>;
export type ListTagsLazyQueryHookResult = ReturnType<typeof useListTagsLazyQuery>;
export type ListTagsQueryResult = Apollo.QueryResult<ListTagsQuery, ListTagsQueryVariables>;